import { VueQueryPlugin } from '@tanstack/vue-query'

import { createHead } from '@shared/libs/unhead'
import sanitize from '@shared/plugins/sanitize'

import { vueQueryPluginOptions } from '@shared/config/vueQuery.plugin.config'

import { setupSiteScripts } from '@shared/global/site.scripts'

const head = createHead()

export function setupApplication (app) {
  // setup plugins that all apps should have access to
  app.use(head)
  app.use(sanitize)
  app.use(VueQueryPlugin, vueQueryPluginOptions)

  setupSiteScripts(head)
}
